import React, { useCallback, useState } from "react";
import { SearchBar, SearchBarProps } from "./SearchBar";

const groups = [
  {
    key: "/app/catalog/search",
    value: "Serviços",
  },
];

export const SearchBarContainer = () => {
  const [selectedGroup, setSelectedGroup] = useState(groups[0].key);
  const [text, setText] = useState();

  const onTextChange = useCallback(
    (text) => {
      setText(text);
    },
    [setText]
  );

  const onGroupChange = useCallback(
    (group) => {
      setSelectedGroup(group);
    },
    [setSelectedGroup]
  );

  const onClickSearch = useCallback(() => {
    if (!text) {
      return;
    }
    window.open(`${selectedGroup}/${text}`, "_self");
  }, [text, selectedGroup]);

  const props: SearchBarProps = {
    groups,
    placeholderText: "Procure por um serviço",
    onTextChange,
    onGroupChange,
    selectedGroup,
    onClickSearch,
  };
  return React.createElement(SearchBar, props);
};
